import React from 'react'

export const Loading = () => {
 return (
  <div>
   <h1 id="loading">Loading...</h1>
  </div>
 )
}
